import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store';
import './index.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.config.productionTip = false

Vue.use(VueToast);
Vue.use(VueYouTubeEmbed);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
